import React from 'react'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import HistoryContent from '../components/HistoryContent/HistoryContent'

const History = () => {
  return (
    <div>
        <Header />
        <HistoryContent />
        <Footer />
    </div>
  )
}

export default History